module.exports = __webpack_public_path__ + "static/12-be9294d58ccf0d54e9df35225d865618.jpg";